var React = require('react');

function ArquetipoArrowTop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .arrow {\n        fill: none;\n        stroke: #707070;\n      }\n    ")),React.createElement("path",{"className":"arrow","d":"M.35,4.71l4-4,4,4","key":1})]);
}

ArquetipoArrowTop.defaultProps = {"width":"8.702","height":"5.058","viewBox":"0 0 8.702 5.058"};

module.exports = ArquetipoArrowTop;

ArquetipoArrowTop.default = ArquetipoArrowTop;
